import React from "react";
import { Button, DialogTitle, Dialog, DialogActions } from "@material-ui/core";

export default function ConfirmDialog({
  open,
  message,
  cancelAction,
  confirmAction,
}) {
  return (
    <Dialog
      open={open}
      onClose={cancelAction}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className="c-text-center" id="alert-dialog-title">{message}</DialogTitle>

      <DialogActions>
        <Button className="c-btn-cancel" color="primary" onClick={cancelAction}>
          Cancelar
        </Button>
        <Button
          className="c-btn-success"
          color="primary"
          autoFocus
          onClick={confirmAction}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
